export const getLocalUserState = store => store.authentication.localUser;
export const getEmail = store => store.authentication.localUser.email;
